import React, { useEffect, useState } from 'react';
import { Box, TextField, withStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { filters } from './styles';
import { useReportFilterItems } from '../../../hooks/reportFilterItems';

function PaymentMethodsFilters({ classes, label, handleFilterChange, filters }) {
    const { paymentMethods } = useReportFilterItems();
    const [selectedItems, setSelectedItems] = useState([]);
    const [isFirstRender, setIsFirstRender] = useState(true);

    const handleChange = items => {
        handleFilterChange({
            paymentMethod: items ?? []
        });
        setSelectedItems(items ?? []);
    };

    useEffect(() => {
        if (!isFirstRender) return;
        if (paymentMethods.length > 0) {
            const values = filters['paymentMethod'];
            if (values) {
                setSelectedItems(values);
            } else {
                setSelectedItems([]);
            }
            setIsFirstRender(false);
        }
        // eslint-disable-next-line
    }, [filters, paymentMethods]);

    return (
        <Box marginTop={4}>
            <Autocomplete
                multiple
                className={`${classes.autocomplete} ${classes.filterMaxWidth}`}
                options={paymentMethods}
                value={selectedItems}
                onChange={(_, item) => handleChange(item)}
                loading={!paymentMethods.length}
                label={label}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                input: classes.autocompleteInputProps
                            }
                        }}
                        InputLabelProps={{
                            ...params.InputLabelProps,
                            className: classes.autocompleteLabelProps
                        }}
                    />
                )}
                renderOption={option => {
                    return <p className={classes.autocompleteOptions}>{option}</p>;
                }}
                ChipProps={{ className: classes.autocompleteChipProps }}
            />
        </Box>
    );
}

export default withStyles(filters)(PaymentMethodsFilters);
